import { z } from 'zod';
import { isValidCnp } from '../lib/cnp';

/** Validation for the "add patient" (attach) form. Messages are i18n keys. */
export const addPatientSchema = z.object({
  cnp: z
    .string()
    .trim()
    .regex(/^\d{13}$/, 'patients.add.cnp_invalid')
    // Check digit (cifra de control) — reject bad CNPs before hitting the API.
    .refine(isValidCnp, 'patients.add.cnp_checksum'),
  activationCode: z.string().trim().min(1, 'patients.add.code_required'),
});

export type AddPatientFormValues = z.infer<typeof addPatientSchema>;
